import { Box, chakra, IconButton } from '@chakra-ui/react';
import styled from '@emotion/styled';
import ScreenSize from '@view/constants/screen-sizes';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    flex-direction: column;
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  gap: 16px;
  justify-content: start;
  align-items: center;
`;

export const StyledBackButton = chakra(IconButton, {
  baseStyle: {
    borderWidth: '1px',
    borderRadius: '8px',
    borderColor: 'neutral.500',
    width: '40px',
    height: '40px',
    backgroundColor: 'white',
    margin: '12px 0px',
  },
});

export const StyledSideComponent = styled(Box)`

  position: relative;
  display:flex;
  flex-direction: column;

  width: 340px;
  min-width: 340px;
  margin-left: 40px;
  
  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    width: 100%;
    margin-left: unset;
  }
`;
